// Generated by ReScript, PLEASE EDIT WITH CARE


var successResponse = [
    {
      "id": 82,
      "engagement_type": "trip_based",
      "crn": "crn000000000",
      "msisdn": "000000000000",
      "driver_name": "Madhu test",
      "date": 1703102400000,
      "penalty_type": "Bad driver behavior",
      "amount": 0.0,
      "applied_at": 1703745633000,
      "applied_by": "abc@xyz.com",
      "is_waived_off": false,
      "category": "N/A",
      "is_deleted": true,
      "deleted_at": 1703756624000,
      "deleted_by": "abc@xyz.com",
      "comment": "test"
    },
    {
      "id": 83,
      "engagement_type": "trip_based",
      "crn": "crn000000000",
      "msisdn": "000000000000",
      "driver_name": "Madhu test",
      "date": 1703102400000,
      "penalty_type": "Bad driver behavior",
      "amount": 0.0,
      "applied_at": 1703756584000,
      "applied_by": "abc@xyz.com",
      "is_waived_off": false,
      "category": "N/A",
      "is_deleted": false,
      "deleted_at": null,
      "deleted_by": null,
      "deletion_comment": null
    },
  ];

export {
  successResponse ,
  
}
/* No side effect */
